import combineReducers from './combineReducers';
import app from './app';
import items from './items';

const reducer = combineReducers({
  app,
  items
});

export default reducer;